export default "* Sang\n* Fællessang\n* Musik\n* Rytme";